import { useState } from "react";
import { memes } from "@/mocks/guaData";

const cats = ["全部", "惊讶", "吃瓜", "嘲讽", "嗑糖", "摆烂"];

export default function MemeWall() {
  const [cat, setCat] = useState("全部");
  const [saved, setSaved] = useState<Set<string>>(new Set());

  const list = cat === "全部" ? memes : memes.filter((m) => m.category === cat);

  const toggleSave = (id: string) => {
    setSaved((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <section id="memes" className="bg-background-100 py-14 md:py-20">
      <div className="container-page">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
              🎭 热门表情包专区
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              吃瓜不斗图，等于没吃瓜。精选全网最好用的表情包任你收藏。
            </p>
          </div>
          <div className="flex w-full flex-wrap gap-2 rounded-full border border-background-200 bg-background-50 p-1 sm:w-auto">
            {cats.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setCat(f)}
                className={`cursor-pointer rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${
                  cat === f
                    ? "bg-accent-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-200"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-3">
          {list.map((m) => (
            <figure
              key={m.id}
              className="group animate-pop overflow-hidden rounded-2xl bg-background-50 p-3 transition-transform hover:-translate-y-1"
            >
              <div className="relative overflow-hidden rounded-xl">
                <img
                  src={m.img}
                  alt={`搞笑表情包：${m.title}`}
                  className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-56"
                />
                <button
                  type="button"
                  onClick={() => toggleSave(m.id)}
                  className="absolute right-2 top-2 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/90 text-foreground-700 backdrop-blur transition-colors hover:text-primary-600"
                  aria-label="收藏表情包"
                >
                  <i
                    className={`${
                      saved.has(m.id)
                        ? "ri-heart-3-fill text-primary-500"
                        : "ri-heart-3-line"
                    }`}
                  ></i>
                </button>
              </div>
              <figcaption className="flex items-center justify-between px-1 pt-3">
                <p className="whitespace-nowrap text-sm font-bold text-foreground-900">
                  {m.title}
                </p>
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-download-2-line"></i>
                  {m.download}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}